<template>
  <v-row>
    <NextEmailsTable
      v-model="openNextEmailsTable"
      @openPageDetails="openContactPageDetails($event)"
      @loadMore="loadMoreNextEmails($event)"
      :loading-next-emails="loadingNextEmails"
      :limit="limit"
      :next-emails="mergedNextEmails"
    />
    <v-col
      cols="12"
      class="py-4"
    >
      <div class="text-title-medium text-primary">
        {{ $t('dashboard.next-emails.title') }}
      </div>
      <div
        class="text-body-medium"
        v-if="mergedNextEmails?.length && !loadingNextEmails"
      >
        <p>{{ $t('dashboard.next-emails.subtitle') }}</p>
      </div>
      <template v-if="mergedNextEmails?.length && !loadingNextEmails">
        <div
          :class="{ 'pb-4': index === mergedNextEmails?.length - 1 }"
          v-for="(email, index) in mergedNextEmails.filter((email, index) => index < 3)"
          :key="email.id"
        >
          <next-email
            @openPageDetails="openContactPageDetails($event)"
            :next-email="email"
            :has-conversion-types="hasConversionTypes"
          />
        </div>
        <div
          v-if="mergedNextEmails?.length > 3"
          class="d-flex justify-center pb-0 px-0"
        >
          <span
            class="view-all text-center"
            @click="handleOpenNextEmailsTable"
          >
            {{ $t('dashboard.next-emails.view-all') }}
          </span>
        </div>
      </template>
      <tempalte v-else-if="loadingNextEmails">
        <v-skeleton-loader
          :style="{ width: $vuetify.display.mdAndUp ? '82%' : '100%', height: '400px' }"
          class="mx-auto"
          type="article"
        />
      </tempalte>
      <template v-else>
        <EmptyState
          @openPage="openContactsPage"
          :title="$t('dashboard.next-emails.empty-state.0')"
          :subtitle="$t('dashboard.next-emails.empty-state.1')"
          :btn-label="$t('dashboard.next-emails.empty-state.2')"
          :icon="'mdi-rocket-launch-outline'"
        />
      </template>
    </v-col>
  </v-row>
</template>
<script setup lang="ts">
import { useQuery } from '@vue/apollo-composable'
import { computed, ref, watch } from 'vue'
import { useRouter } from 'vue-router'

import EmptyState from '@/modules/dashboard/nextEmails/EmptyState.vue'
import NextEmail from '@/modules/dashboard/nextEmails/NextEmail.vue'
import NEXT_EMAILS from '@/modules/dashboard/nextEmails/nextEmails.gql'
import NextEmailsTable from '@/modules/dashboard/nextEmails/NextEmailsTable.vue'
const route = useRouter()
const openNextEmailsTable = ref(false)
const currentPage = ref(1)
const limit = ref(10)
const mergedNextEmails = ref([])

const {
  result: nextEmails,
  loading: loadingNextEmails,
  refetch: refetchNextEmails,
} = useQuery(NEXT_EMAILS, {
  input: {
    limit: 10,
    page: 1,
  },
})

const openContactsPage = () => {
  route.push({
    path: '/leads/list',
    query: {
      toolOpen: 'acquisition',
    },
  })
}

const openContactPageDetails = (id) => {
  route.push({
    path: `/leads/${id}`,
    query: {
      timelineOpen: 'nextEmail',
    },
  })
}

const loadMoreNextEmails = async (page) => {
  currentPage.value = page
  limit.value = 10
  await refetchNextEmails({
    input: {
      limit: 10,
      page,
    },
  })
}

const handleOpenNextEmailsTable = async () => {
  openNextEmailsTable.value = true
}
const hasConversionTypes = computed(() =>
  mergedNextEmails.value.some((email) => Object.keys(email.conversionCountByType).length > 0)
)

watch(
  () => nextEmails.value?.nextMessages,
  (newMessages) => {
    if (!Array.isArray(newMessages)) return
    mergedNextEmails.value = [...mergedNextEmails.value, ...newMessages]
  },
  { immediate: true }
)
</script>

<style scoped>
.view-all {
  color: #175e51;
  cursor: pointer;
  font-weight: 400;
  font-size: 16px;
  line-height: 56px;
  text-align: right;
  vertical-align: middle;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: auto;
}
</style>
